import { destroy } from "@/application/api";

export const conceptSalesOrderDestroy = ({
  clientId,
  salesOrderId,
}: {
  clientId: number;
  salesOrderId: number;
}) => destroy(`client/${clientId}/sales-order/concept/${salesOrderId}`);
